import { hookFactory } from "./useHook";

export const useCheckout = hookFactory("checkout");
export const useCart = hookFactory("cart");
